module.exports = __webpack_public_path__ + "static/media/about-bg.e8c79ae6.webp";